<template>
	<div class="detail-wrap">
		<div class="cm  fw u-text-center" style="font-size: 18px;">{{data.title}}</div>
		<div class="cgray  u-m-t-10 u-text-center" style="font-size: 14px;">发布时间：{{moment(data.updated_at).format('YYYY-MM-DD HH:mm:ss')}}</div>
		<div v-html="data.detail_info" class="info u-m-t-20 edit-back"></div>
	</div>
</template>

<script>
	export default {
		name: 'Detail',
		data() {
			return {
				data: {}
			}
		},
		mounted() {
			this.data=JSON.parse(localStorage.getItem('article'))
		}
	}
</script>

<style scoped>
	.detail-wrap{
		/* padding: 80px 100px; */
		/* height: 100vh; */
		padding: 40px 10px;
		box-sizing: border-box;
		width: 100%;
		margin: 20px auto 0;
		max-width: 1000PX;
		background-color: #fff;
	}
	/* >>>不能用less会报错 */
	.info>>>img{
		max-width: 100% !important;
		width: 100%;
		/* margin: 20px; */
	}
	.info{
		color: #333;
		/* line-height: 26px;
		font-size: 14px; */
	}
</style>
